//
//
//
//
//
//
export default {
  name: 'CoreSplitButton',
  inheritAttrs: false,
  props: {
    color: {
      type: String,
      default: ''
    }
  },
  data: function data() {
    return {
      commonAttrs: {}
    };
  }
};